import { getTypesHandler } from './getTypes';

export const getResultCountHandler = component => {
  const getTypes = getTypesHandler(component);

  return data => {
    const results = data.result;
    let result;
    let total = results?.bestMatch?.length ?? 0;

    if (results.nowPlaying) {
      total += results.nowPlaying.length;
    }

    if (component.NEW_SEARCH) {
      total += results.results.length;
    } else {
      getTypes().forEach(type => {
        result = results[type.key];
        if (!result || !result.data || !result.data.length) {
          return;
        }
        total += result.data.length;
      });
    }

    component.setState(() => ({ showMoreVisible: total >= 20 }));

    return total;
  };
};
